import React from 'react';
import {
  Form,
  Label,
  FormGroup,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { FormField, CheckFormField } from '../../../../../utils/FormFields';

function SignatureSetsTab({
  account, changedAccount, showChanges,
}) {
  const editSignatureSet = changedAccount.SignatureSets[0];
  let compareSignatureSet;
  account.SignatureSets.map((s) => {
    if (parseInt(s.SignatureSetId, 10) === parseInt(editSignatureSet.SignatureSetId, 10)) {
      compareSignatureSet = s;
    }
    return {};
  });
  let color = 'black';
  if (showChanges) {
    if (compareSignatureSet && editSignatureSet.SignatureSetWayOfAction === 'NoAction') {
      color = 'red';
    } else if (compareSignatureSet) {
      color = '#36a9e1';
    } else {
      color = 'green';
    }
  }
  return (
    <Form>
      <Label style={{
        fontWeight: 500,
        fontSize: '20px',
        display: 'block',
        color,
      }}
      >
        {showChanges
          ? (
            <React.Fragment>
              {editSignatureSet.SignatureSetId > 0
                ? (
                  <React.Fragment>
                    {editSignatureSet.SignatureSetWayOfAction === 'NoAction' ? 'Remove Signature Set' : 'Edit Signature Set'}
                  </React.Fragment>
                )
                : 'New Signature Set'}
            </React.Fragment>
          )
          : 'Actual Account'}
      </Label>
      {showChanges
        ? (
          <FormGroup tag="fieldset">
            {editSignatureSet.SignatureSetWayOfAction !== 'NoAction'
              && <FormToShow signatureSet={editSignatureSet} refSet={compareSignatureSet} />}
          </FormGroup>
        )
        : (
          <FormGroup tag="fieldset">
            {compareSignatureSet && <FormToShow signatureSet={compareSignatureSet} />}
          </FormGroup>
        )}
    </Form>
  );
}

SignatureSetsTab.propTypes = {
  changedAccount: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
  showChanges: PropTypes.bool.isRequired,
};

export default SignatureSetsTab;

const FormToShow = ({ signatureSet, refSet }) => (
  <React.Fragment>
    <FormField
      name="SignatureSetId"
      value={signatureSet.SignatureSetId}
      label="Id"
    />
    <FormField
      name="SignatureSetPersonName"
      value={signatureSet.SignatureSetPersonName}
      label="Person Name"
      changedColor={refSet
        && parseInt(signatureSet.SignatureSetPersonId, 10)
        !== parseInt(refSet.SignatureSetPersonId, 10)}
    />
    <FormField
      name="SignatureSetWayOfAction"
      value={signatureSet.SignatureSetWayOfAction}
      label="Way of Action"
      changedColor={refSet
        && signatureSet.SignatureSetWayOfAction !== refSet.SignatureSetWayOfAction}
    />
    {signatureSet.SignaturePeopleSelected.map((p) => (
      <React.Fragment>
        <CheckFormField
          label={p.SignaturePersonName}
          value
          initialValue
          disabled
          changedColor={refSet}
        />
      </React.Fragment>
    ))}
  </React.Fragment>
);

FormToShow.propTypes = {
  signatureSet: PropTypes.object.isRequired,
  refSet: PropTypes.object,
};

FormToShow.defaultProps = {
  refSet: undefined,
};
